import React from 'react';
import * as SwitchPrimitives from '@radix-ui/react-switch';
import { useFormContext } from 'react-hook-form';

import { cn } from '@epoch-ui/lib/utils';
import { Switch } from '@epoch-ui/components/Switch/switch';

import { FormControl, FormDescription, FormField, FormItem, FormLabel } from '../../form';

export interface SwitchFieldProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  name: string;
  label?: string | React.ReactNode;
  description?: string | React.ReactNode;
}

export const SwitchField = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchFieldProps
>(({ name, label, description, className, ...props }, ref) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn('tw-flex tw-items-center tw-justify-start tw-gap-2', className)}>
          <FormControl>
            <Switch
              className="tw-mt-0"
              ref={ref}
              checked={field.value}
              onCheckedChange={props.onCheckedChange || field.onChange}
              {...props}
            />
          </FormControl>
          {label && (
            <div
              className={cn(
                'tw-grid tw-gap-1.5 tw-leading-none',
                props.disabled && 'tw-opacity-40'
              )}
            >
              <FormLabel>{label}</FormLabel>
              {description && <FormDescription>{description}</FormDescription>}
            </div>
          )}
        </FormItem>
      )}
    />
  );
});
SwitchField.displayName = 'SwitchField';
